import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Auth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class EnquiryService {
  private readonly baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private auth: Auth
  ) {}

  // Get HTTP headers with authorization token
  private async getHeaders(): Promise<HttpHeaders> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    if (this.auth.currentUser) {
      try {
        const token = await this.auth.currentUser.getIdToken();
        headers = headers.set('Authorization', `Bearer ${token}`);
      } catch (error) {
        console.warn('⚠️ [EnquiryService] Failed to get ID token:', error);
      }
    }

    return headers;
  }

  // Submit an enquiry
  async submitEnquiry(data: { name: string; email: string; phone: string; message: string }): Promise<any> {
    const headers = await this.getHeaders();
    return this.http.post(`${this.baseUrl}/enquiry`, data, { headers }).toPromise();
  }
}